<template>
    <v-card class="mt-2" flat>
        <v-row no-gutters>
            <v-col md="6">
                <v-card elevation="0" class="px-4">
                    <!-- <v-row>
                        <v-col md="12" class="mb-1 mt-1">
                            <h4 class="font-weight-light primary--text">
                                Datos
                            </h4>
                        </v-col>
                    </v-row>
                    <v-divider></v-divider> -->
                    <v-row class="mb-n7">
                        <v-col lg="6" xl="6" cols="12">
                            <v-text-field
                                v-model="Name"
                                label="Nombre"
                                style="padding: 21.1px 0px 17px 0px"
                            ></v-text-field>
                        </v-col>
                        <v-col md="6">
                            <v-select
                                clearable
                                chips
                                :items="opciones.tarifas.operator"
                                item-value="encoded"
                                item-text="human"
                                v-model="Operator"
                                :label="Operator ? Operator : 'Operador'"
                            >
                                <template #selection="{ item }">
                                    <v-chip
                                        :color="
                                            isEditableForm
                                                ? 'primary lighten-3'
                                                : 'primary'
                                        "
                                        class="white--text"
                                    >
                                        <v-icon> mdi-signal-variant </v-icon>
                                        {{ item.human }}
                                    </v-chip>
                                </template>
                            </v-select>
                        </v-col>
                    </v-row>
                </v-card>
            </v-col>
            <v-col md="6" cols="12">
                <v-card elevation="0" class="px-4">
                    <!-- <v-row>
                        <v-col md="12" class="mb-1 mt-1">
                            <h4 class="font-weight-light primary--text">
                                Pricing
                            </h4>
                        </v-col>
                    </v-row>
                    <v-divider></v-divider> -->
                    <v-row class="mb-n7">
                        <v-col xl="4" lg="4" cols="6">
                            <v-text-field
                                v-model="Tramo"
                                label="Tramo"
                                style="padding: 21.1px 0px 17px 0px"
                            ></v-text-field>
                        </v-col>
                        <v-col
                            xl="2"
                            lg="2"
                            cols="6"
                            style="padding: 21px 10px 0px 10px"
                        >
                            <v-select
                                hide-selected
                                :items="['€']"
                                label="Unidad"
                                value="€"
                                disabled
                            >
                            </v-select>
                        </v-col>
                        <v-col xl="4" lg="4" cols="6">
                            <v-text-field
                                :disabled="formType != 'add'"
                                v-model="Price"
                                label="Precio"
                                style="padding: 21.1px 0px 17px 0px"
                            ></v-text-field>
                        </v-col>
                        <v-col
                            xl="2"
                            lg="2"
                            cols="6"
                            style="padding: 21px 10px 0px 10px"
                        >
                            <v-select
                                hide-selected
                                :items="['€']"
                                label="Unidad"
                                value="€"
                                disabled
                            >
                            </v-select>
                        </v-col>
                    </v-row>
                </v-card>
            </v-col>
            <!-- <v-col cols="3" class="pl-1">
                                    <v-card class="px-4" text>
                                        <v-row>
                                            <v-col md="12" class="mb-1 mt-1">
                                                <h4
                                                    class="
                                                        font-weight-light
                                                        primary--text
                                                    "
                                                >
                                                    Upfront
                                                </h4>
                                            </v-col>
                                        </v-row>
                                        <v-divider></v-divider>
                                        <v-row class="mb-n7 mt-n2">
                                            <v-col md="9">
                                                <v-text-field
                                                    v-model="Upfront"
                                                    label="Cantidad"
                                                    required
                                                    style="
                                                        padding: 21.1px 0px 12px
                                                            0px;
                                                    "
                                                ></v-text-field>
                                            </v-col>
                                            <v-col
                                                md="3"
                                                style="
                                                    padding: 21px 10px 0px 10px;
                                                "
                                            >
                                                <v-select
                                                    hide-selected
                                                    :items="['€']"
                                                    label="Unidad"
                                                    value="€"
                                                    disabled
                                                >
                                                </v-select>
                                            </v-col>
                                        </v-row>
                                    </v-card>
                                </v-col> -->
        </v-row>
    </v-card>
</template>

<script>
import { mapState } from 'vuex';

export default {
    name: 'insuranceManagementForm',
    data: () => ({}),
    methods: {
        clearFields() {
            this.$store.state.ManagementBase.insuranceManagement.Name = '';
            this.$store.state.ManagementBase.insuranceManagement.Operator = '';
            this.$store.state.ManagementBase.insuranceManagement.Price = '';
            this.$store.state.ManagementBase.insuranceManagement.Upfront = 0;
            this.$store.state.ManagementBase.insuranceManagement.Tramo = '';
            this.$store.state.ManagementBase.insuranceManagement.IsActive = false;
        },
        closeForm() {
            this.$store.commit(
                'ManagementBase/insuranceManagement/isOpenDialog',
                false
            );
            this.clearFields();
        },
        submitInsurance() {
            if (
                this.$store.state.ManagementBase.insuranceManagement.formType ==
                'add'
            )
                this.$store.dispatch(
                    'ManagementBase/insuranceManagement/addInsurance'
                );
            else
                this.$store.dispatch(
                    'ManagementBase/insuranceManagement/editInsurance'
                );

            this.closeForm();
        },
    },
    computed: {
        isOpenDialog: {
            get() {
                return this.$store.state.ManagementBase.insuranceManagement
                    .isOpenDialog;
            },
            set(val) {
                this.$store.commit(
                    'ManagementBase/insuranceManagement/isOpenDialog',
                    val
                );
                this.clearFields();
            },
        },
        Name: {
            get() {
                return this.$store.state.ManagementBase.insuranceManagement
                    .Name;
            },
            set(val) {
                this.$store.commit(
                    'ManagementBase/insuranceManagement/Name',
                    val
                );
            },
        },
        Operator: {
            get() {
                return this.$store.state.ManagementBase.insuranceManagement
                    .Operator;
            },
            set(val) {
                this.$store.commit(
                    'ManagementBase/insuranceManagement/Operator',
                    val
                );
            },
        },
        Price: {
            get() {
                return this.$store.state.ManagementBase.insuranceManagement
                    .Price;
            },
            set(val) {
                this.$store.commit(
                    'ManagementBase/insuranceManagement/Price',
                    val
                );
            },
        },
        Upfront: {
            get() {
                return this.$store.state.ManagementBase.insuranceManagement
                    .Upfront;
            },
            set(val) {
                this.$store.commit(
                    'ManagementBase/insuranceManagement/Upfront',
                    val
                );
            },
        },
        Tramo: {
            get() {
                return this.$store.state.ManagementBase.insuranceManagement
                    .Tramo;
            },
            set(val) {
                this.$store.commit(
                    'ManagementBase/insuranceManagement/Tramo',
                    val
                );
            },
        },
        IsActive: {
            get() {
                return this.$store.state.ManagementBase.insuranceManagement
                    .IsActive;
            },
            set(val) {
                this.$store.commit(
                    'ManagementBase/insuranceManagement/IsActive',
                    val
                );
            },
        },
        isEditableForm: {
            get() {
                return this.$store.state.ManagementBase.insuranceManagement
                    .isEditableForm;
            },
            set(val) {
                this.$store.commit(
                    'ManagementBase/insuranceManagement/isEditableForm',
                    val
                );
            },
        },
        opciones() {
            return JSON.parse(localStorage.getItem('opciones'));
        },
        ...mapState('ManagementBase', {
            formType: (state) => state.baseForm.formType,
        }),
    },
};
</script>
